import changeBillAddressApi from '@/api/changeBillAddress/changeBillAddressApi.js'

export default {
	name: 'change-bill-address',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			isEditing: false, // 是否正在修改帳單地址（default: false）
			districtOfCity:[],
			changeInfo: {
				zipCode:'',
				cityId:'',
				districtId:'',
				address:'',
			},
			getBillAddressInfoResp: {
				billAddress: {
					fullAddress:'',
					cityId:'',
					districtId:'',
					zipCode:'',
					address:'',
				},
				citys:[
					{
						id:'',
						order:'',
						name:'',
						districts:[
							{
								id:'',
								order:'',
								name:'',
								zipCode:'',
							},
						],
					}
				],
			},
		};
	},
	computed: {
	},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		
		async init() {
			this.getBillAddressInfoResp = await changeBillAddressApi.getBillAddressInfo();

			// sort by order
			this.getBillAddressInfoResp.citys.sort(function(c1, c2){
				return c1.order - c2.order;
			});
			for (let i in this.getBillAddressInfoResp.citys) {
				let city = this.getBillAddressInfoResp.citys[i];
				city.districts.sort(function(d1, d2){
					return d1.order - d2.order;
				});
			}

			if (this.getBillAddressInfoResp.billAddress.zipCode) {
				this.changeInfo.zipCode = this.getBillAddressInfoResp.billAddress.zipCode;
			}
			if (this.getBillAddressInfoResp.billAddress.cityId) {
				this.changeInfo.cityId = this.getBillAddressInfoResp.billAddress.cityId;
			}
			if (this.getBillAddressInfoResp.billAddress.districtId) {
				this.changeInfo.districtId = this.getBillAddressInfoResp.billAddress.districtId;
			}
			if (this.getBillAddressInfoResp.billAddress.address) {
				this.changeInfo.address = this.getBillAddressInfoResp.billAddress.address;
			}

			this.updateDistrict(false);
		},

		async changeSubmit() {

			// 使用者輸入驗證
			const isValid = await this.$validator.validate();	
			if(!isValid){
				return;
			}

			let payload = {
				cityId: this.changeInfo.cityId,
				districtId: this.changeInfo.districtId,
				address: this.changeInfo.address,
			};

			const changeBillAddressResp = await changeBillAddressApi.changeBillAddress(payload);
			if (changeBillAddressResp) {
				this.$router.push({ name: 'gt-success', params: { title: '修改帳單地址', msg: '帳單地址修改成功', returnName: 'change-bill-address' } });
			}
		},

		updateDistrict(initDistrictId) {
			if (!this.changeInfo.cityId) {
				return;
			}
			for (let i in this.getBillAddressInfoResp.citys) {
				const city = this.getBillAddressInfoResp.citys[i];
				if (this.changeInfo.cityId == city.id) {
					this.districtOfCity = city.districts;
					if (initDistrictId) this.changeInfo.districtId = '';
					break;
				}
			}
			this.updateZipCode();
		},

		updateZipCode() {
			if (!this.changeInfo.districtId) {
				return;
			}
			for (let i in this.districtOfCity) {
				const district = this.districtOfCity[i];
				if (this.changeInfo.districtId == district.id) {
					this.changeInfo.zipCode = district.zipCode;
					break;
				}
			}
		},

		// 確認中文占兩字元, 英文占一字元, 不超過 40 字元
		checkAddressLength() {
			// 最後輸出字串
			let finalStr = '';
			// 紀錄目前長度
			let curLength = 0;
			// 中文判斷
			let regChi = /[\u4e00-\u9fa5]/;
			if(this.changeInfo.address) {
				for(let str of this.changeInfo.address) {
					if(curLength > 40) {
						break;
					}
					if(regChi.test(str)) {
						curLength += 2;
					} else {
						curLength++;
					}
					if(curLength <= 40) {
						finalStr += str;
					}
				}
				
			}
			this.changeInfo.address = finalStr;
		}


	}
};



// WEBPACK FOOTER //
// ./src/components/changeBillAddress/changeBillAddress.js